import { BaseApiClient } from './base'
import type { TranslationCostEstimate } from '../../types'

export class TranslationCostApi extends BaseApiClient {
  async estimateTranslation(params: {
    bookId: string
    targetLanguage: string
    cefrLevel: string
    modelId?: string
  }): Promise<TranslationCostEstimate> {
    const response = await this.request(`/user/books/${params.bookId}/estimate-translation`, {
      method: 'POST',
      body: JSON.stringify({
        language: params.targetLanguage,
        cefr_level: params.cefrLevel,
        model_id: params.modelId,
      }),
    })
    return response.estimate
  }

  async estimateTranslationCost(
    bookId: string,
    language: string,
    cefrLevel: string,
    modelId?: string
  ): Promise<{ success: boolean; estimate: TranslationCostEstimate }> {
    return this.request(`/user/books/${bookId}/estimate-translation`, {
      method: 'POST',
      body: JSON.stringify({
        language,
        cefr_level: cefrLevel,
        model_id: modelId,
      }),
    })
  }

  async queueTranslationWithEstimate(
    bookId: string,
    language: string,
    cefrLevel: string,
    estimateId: string,
    confirmed: boolean = true
  ): Promise<{ success: boolean; translation_id: string; cost: number; was_free: boolean }> {
    return this.request(`/user/books/${bookId}/queue-translation`, {
      method: 'POST',
      body: JSON.stringify({
        language,
        cefr_level: cefrLevel,
        estimate_id: estimateId,
        confirmed,
      }),
    })
  }
}

